/**
 * Applies the server's cart check (POST /cart/validate) to the cart saved in this browser: a changed price is
 * updated, a product no longer for sale is removed, a quantity above the stock left is lowered. Returns the new items
 * and one short notice per change, so the shopper sees the total they will really pay. Lines are matched by product
 * and variant; `variantIdOf` gives a cart line's variant id.
 */
export function applyCartCheck(items, issues, variantIdOf) {
  const notices = [];
  let next = [...items];
  const matches = (item, issue) => item.id === issue.productId
    && (issue.variantId == null || variantIdOf(item) === issue.variantId);
  const money = (item, value) => `${item.currencySymbol || '₹'}${Number(value).toLocaleString('en-IN')}`;

  for (const issue of issues || []) {
    if (issue.productId == null) continue;
    const item = next.find((i) => matches(i, issue));
    if (!item) continue;
    const name = item.title || 'An item';
    if (issue.issue === 'PRICE_CHANGED' && issue.currentPrice != null) {
      if (Number(item.price) === Number(issue.currentPrice)) continue;
      notices.push(`${name}: price is now ${money(item, issue.currentPrice)} (was ${money(item, item.price)})`);
      next = next.map((i) => (i === item ? { ...i, price: Number(issue.currentPrice) } : i));
    } else if (issue.issue === 'PRODUCT_NOT_FOUND' || issue.issue === 'VARIANT_NOT_FOUND'
        || (issue.issue === 'INSUFFICIENT_INVENTORY' && !(issue.availableQuantity > 0))) {
      notices.push(`${name} is no longer available and was removed from your cart`);
      next = next.filter((i) => i !== item);
    } else if (issue.issue === 'INSUFFICIENT_INVENTORY') {
      notices.push(`Only ${issue.availableQuantity} of ${name} left — quantity updated`);
      next = next.map((i) => (i === item ? { ...i, quantity: issue.availableQuantity } : i));
    }
  }
  return { items: next, notices };
}
